const LABELS = {
  TRIANGLE: '三角形',
  SQUARE: '正方形',
  STAR: '五角星',
  CIRCLE: '椭圆形',
  PENTAGON: '五边形',
  PLUS: '加号',
  QUARTER_CIRCLE: '四分之一圆',
  TRAPEZOID: '梯形',
  DIAMOND: '菱形'
};
export default {
  name: 'DigitSymbolShape',
  props: {
    shapeId: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 64
    }
  },
  computed: {
    shapeLabel() {
      return LABELS[this.shapeId] || '图形';
    }
  }
};